export default "__VITE_ASSET__BMSg87z$__"